import { Link } from "react-router-dom";
import { Award } from "lucide-react";

export default function CourseHeader({ course, stats, certified }) {
  return (
    <div className="flat-card p-7 scanlines">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="font-mono text-xs text-[var(--cyan)]" data-testid="cd-code">{course.code}</div>
          <h1 className="font-display font-bold text-4xl uppercase mt-1" data-testid="cd-title">{course.title}</h1>
          <p className="text-[var(--text-2)] mt-3 max-w-2xl">{course.description}</p>
          <div className="flex flex-wrap gap-2 mt-4">
            <span className="tag tag-cyan">{course.stage}</span>
            <span className="tag">TRK / {course.track}</span>
            <span className="tag">{course.duration_hours}h</span>
            {certified && <span className="tag tag-green inline-flex items-center gap-1"><Award size={12} /> Certified</span>}
          </div>
        </div>
        <div className="text-right">
          <div className="overline">// COURSE_PROGRESS</div>
          <div className="font-mono text-5xl text-[var(--cyan)] mt-1" data-testid="cd-progress">{stats.progress}%</div>
          <div className="font-mono text-xs text-[var(--text-2)] mt-1">
            {stats.completed_lessons} / {stats.total_lessons} lessons
          </div>
          <div className="progress-track mt-3 w-48">
            <div className="progress-fill" style={{ width: `${stats.progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export function BackToCourses() {
  return (
    <Link to="/courses" className="inline-flex items-center gap-2 font-mono text-xs text-[var(--text-2)] hover:text-[var(--cyan)] uppercase tracking-widest mb-4" data-testid="back-to-courses">
      ← All Courses
    </Link>
  );
}
